<template>
  <emd-card>
    <emd-card-header>
      <emd-text size="section"> {{ $t('header') }}</emd-text>
    </emd-card-header>
    <emd-card-content>
      <emd-text-section>
        <emd-text-content
          v-if="data.planId"
          :title="$t('planId')"
        >
          <router-link
            class="emd-color__url"
            tag="a"
            target="_blank"
            rel="noopener noreferrer"
            :to="{
              name: 'plansDetail',
              params: {
                id: data.planId,
                tab: 'info'
              }
            }"
          >
            {{ data.planId }}
          </router-link>
        </emd-text-content>

        <emd-text-content :title="$t('expirationDate')">
          <span v-if="data.expirationDate">{{ data.expirationDate }}</span>
          <span v-else> {{ $t('expirationDateFallback') }} </span>
        </emd-text-content>

        <emd-text-content
          :title="$t('shippingCost')"
          :content="data.shippingCost"
        />

        <emd-text-content :title="$t('totalPaidSessions')">
          <span v-if="data.maxPaidSessions">
            {{
              $t('totalPaidSession-content', [
                data.totalPaidSessions,
                data.maxPaidSessions
              ])
            }}
          </span>
          <span v-else> {{ data.totalPaidSessions }} </span>
        </emd-text-content>
      </emd-text-section>

      <emd-text-section
        v-if="data.link.name"
        :title="$t('specificLink')"
      >
        <emd-text-content
          :title="$t('name')"
          :content="data.link.name"
        />
        <emd-text-content
          :title="$t('email')"
          :content="data.link.email"
        />
      </emd-text-section>
      <emd-text-section>
        <emd-text-content
          :title="$t('orderCode')"
          :content="data.orderCode"
        />
      </emd-text-section>
    </emd-card-content>
  </emd-card>
</template>

<script>
import {
  EmdText,
  EmdCard,
  EmdCardHeader,
  EmdCardContent,
  EmdTextSection,
  EmdTextContent
} from 'emerald-vue/src/components'

export default {
  name: 'ConfigurationLink',
  components: {
    EmdTextContent,
    EmdText,
    EmdCard,
    EmdCardHeader,
    EmdCardContent,
    EmdTextSection
  },
  props: {
    data: Object
  }
}
</script>

<i18n>
  {
    "pt-BR": {
      "header": "Configurações do link",
      "planId": "ID do Plano",
      "expirationDate":"Data de expiração",
      "expirationDateFallback": "Não expira",
      "addressType": "Tipo de endereço",
      "shippingCost": "Valor do frete",
      "totalPaidSessions": "Total links pagos",
      "totalPaidSession-content": "{0} de {1}",
      "specificLink": "Link específico",
      "name": "Nome do cliente",
      "email": "E-mail",
      "orderCode": "Código de indentificação"
    },
    "en-US": {
      "header": "Link Configuration",
      "planId": "Plan id",
      "expirationDate":"Expiration date",
      "expirationDateFallback": "Not expirate",
      "addressType": "Address type",
      "shippingCost": "Cost of shipping",
      "totalPaidSessions": "Total paid links",
      "totalPaidSession-content": "{0} of {1}",
      "specificLink": "Specific link",
      "name": "Name of client",
      "email": "E-mail",
      "orderCode": "Identification code"
    }
  }
</i18n>
